module.exports = __webpack_public_path__ + "img/btn_settings.9bb3a9cd.svg";